import { z } from 'zod';

import type { Recommendation } from './recommendation.js';

export const getRecommendationsSchema = z.object({
  search: z.string().optional(),
  category_id: z.uuid().optional(),
  module_id: z.uuid().optional(),
  limit: z
    .string()
    .optional()
    .default('10')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(1).max(100)),
  page: z
    .string()
    .optional()
    .default('0')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(0)),
});

export type GetRecommendationsPayload = z.infer<typeof getRecommendationsSchema>;

export interface GetRecommendationsResponse {
  recommendations: Recommendation[];
  total: number;
  page: number;
  limit: number;
}
